import React from 'react';
import { ArrowDownIcon, ArrowUpDownIcon, ArrowUpIcon } from 'lucide-react';
import type { SortState } from '../../hooks/useSort';
interface SortableThProps<K extends string> {
  label: string;
  sortKey: K;
  sort: SortState<K>;
  onSort: (k: K) => void;
  align?: 'left' | 'right';
  className?: string;
}
export function SortableTh<K extends string>({
  label,
  sortKey,
  sort,
  onSort,
  align = 'right',
  className = ''
}: SortableThProps<K>) {
  const active = sort.key === sortKey;
  const Icon = !active ? ArrowUpDownIcon : sort.dir === 'asc' ? ArrowUpIcon : ArrowDownIcon;
  return <th scope="col" aria-sort={active ? sort.dir === 'asc' ? 'ascending' : 'descending' : 'none'} className={`whitespace-nowrap border-b-2 border-navy/70 px-3 py-2.5 font-semibold ${align === 'right' ? 'text-right' : 'text-left'} ${className}`} data-id="element-736" data-mp="3qigtv1s0223g">
      <button type="button" onClick={() => onSort(sortKey)} className={`inline-flex items-center gap-1 rounded hover:text-navy-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy/30 ${align === 'right' ? 'flex-row-reverse' : ''}`} data-id="element-737" data-mp="1oozok4rcddbv">
        {label}
        <Icon className={`h-3 w-3 ${active ? 'text-navy' : 'text-ink-subtle'}`} aria-hidden data-id="element-738" data-mp="1s58jm2him0fy" />
      </button>
    </th>;
}